
define(
	'Jeske.AnnouncementBanner.ABModule'
,   [
		'Jeske.AnnouncementBanner.ABModule.View'
	]
,   function (
		ABModuleView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');

			if (layout)
			{
				layout.addChildView('Header', function() {
					return new ABModuleView({ container: container });
				});
			}
		}
	};
});
